import { tap, skip, map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../authentication/authentication.service";
var credentialsKey = 'currentUser';
var UsersService = /** @class */ (function () {
    function UsersService(http, authenticationService) {
        this.http = http;
        this.authenticationService = authenticationService;
        this.isSaveAndExit = new BehaviorSubject({ isSaveAndExit: false, currentForm: null });
        this.userDetails = new BehaviorSubject(null);
        this.userDetailsObs = this.userDetails.asObservable();
    }
    UsersService.prototype.registerUser = function (data) {
        var _this = this;
        var href = "" + environment.register;
        return this.http.post(href, data).pipe(tap(function (data) {
            if (data.status === 'success') {
                _this.authenticationService.setUser(data.response);
            }
            return data;
        }));
    };
    UsersService.prototype.updateUserProfile = function (payload) {
        var href = "" + environment.updateProfile;
        return this.http.post(href, payload).pipe(tap(function (data) {
            if (data.status === 'success') {
            }
            return data;
        }));
    };
    UsersService.prototype.setCurrentApplication = function (application) {
        sessionStorage.setItem("application", JSON.stringify(application));
    };
    UsersService.prototype.removeApplication = function () {
        sessionStorage.removeItem("application");
    };
    UsersService.prototype.getCurrentApplication = function () {
        var data = sessionStorage.getItem("application") ? (JSON.parse(sessionStorage.getItem("application")) || null) : null;
        // if(data && data.renewed_application_details){
        //   return data.renewed_application_details
        // }
        return data;
    };
    UsersService.prototype.checkSaveAndExit = function () {
        return this.isSaveAndExit.asObservable().pipe(skip(1));
    };
    UsersService.prototype.getApplicationList = function (pagination) {
        var href = environment.getApplicationList;
        return this.http.get(href, { params: pagination }).pipe(map(function (data) {
            if (data.status == 'success') {
                return data;
            }
        }));
    };
    UsersService.prototype.getExpiringApplications = function (pagination) {
        var href = environment.getExpiringApplications;
        return this.http.get(href, { params: pagination }).pipe(map(function (data) {
            if (data.status == 'success') {
                return data;
            }
        }));
    };
    UsersService.prototype.getApplicationById = function (id) {
        var href = environment.getApplicationById;
        return this.http.get(href, { params: id }).pipe(map(function (data) {
            if (data.status == 'success') {
                return data.response;
            }
        }));
    };
    UsersService.prototype.renewPermit = function (payload) {
        // const href = environment.renewPermit;
        // return this.http.get<any>(href, {params: id}).pipe(map((data: any) => {
        //   if (data.status == 'success') {
        //     return data.response;
        //   }
        // }));
        var href = "" + environment.renewPermit;
        return this.http.post(href, payload).pipe(tap(function (data) {
            if (data.status === 'success') {
            }
            return data;
        }));
    };
    UsersService.prototype.getCityList = function () {
        var href = environment['getCityList'];
        return this.http.get(href).pipe(map(function (data) {
            if (data.status == 'success') {
                return data.response;
            }
        }));
    };
    UsersService.prototype.setSelectedCity = function (id) {
        sessionStorage.setItem('selectedCity', id);
    };
    UsersService.prototype.getSelectedCity = function () {
        return sessionStorage.getItem('selectedCity');
    };
    UsersService.prototype.removeSelectedCity = function () {
        sessionStorage.removeItem('selectedCity');
    };
    UsersService.prototype.verifiyOtpProfile = function (data) {
        var href = environment.verifiyOtpProfile;
        return this.http.post(href, data).pipe(map(function (res) {
            if (res.status === 'success') {
                var storage = localStorage;
                storage.setItem(credentialsKey, JSON.stringify(res.response));
            }
            if (res.status == 'success') {
                return res;
            }
        }));
    };
    UsersService.prototype.sendProfileOtp = function (payload) {
        var href = environment.sendProfileOtp;
        return this.http.get(href, { params: payload }).pipe(map(function (data) {
            if (data.status == 'success') {
                return data;
            }
        }));
    };
    UsersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UsersService_Factory() { return new UsersService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthenticationService)); }, token: UsersService, providedIn: "root" });
    return UsersService;
}());
export { UsersService };
